import { MapboxAPIClass } from "@lib/common";
import { config } from "../../config";

export const MapboxAPI = new MapboxAPIClass({ api_key: config.services.mapbox.api_key });
